import { activeComponent } from "../App";

class EventManager {
  constructor() {
    this.listeners = new Map();
    this.eventQueue = [];
    this.isProcessing = false;
    this.lastEventTimestamp = {};

    window.addEventListener('keydown', this.handleEvent.bind(this), { passive: false });
    window.addEventListener('wheel', this.handleEvent.bind(this));

  }

  handleEvent(event) {
    this.eventQueue.push(event);
    this.processQueue();
  }

  processQueue() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    while (this.eventQueue.length > 0) {
      const event = this.eventQueue.shift();
      this.dispatchEvent(event);
    }

    this.isProcessing = false;
  }

  addListener(type, listener, excludes = [], overides = [], state = "", actions = [], flag = "home") {

    listener.flag = flag;
    listener.excludes = excludes;
    listener.overides = overides;
    listener.state = state;
    listener.actions = actions;

    if (!this.listeners.has(type)) {
      this.listeners.set(type, []);
    }
    this.listeners.get(type).push(listener);
  }

  removeListener(type, listener) {
    if (this.listeners.has(type)) {
      this.listeners.set(type, this.listeners.get(type).filter(l => l !== listener));
    }
  }

  press(options = {}) {
    const event = new KeyboardEvent("keydown", options);
    this.dispatchEvent(event);
  }

  dispatchEvent(event) {
    const type = event.type;
    const currentTime = Date.now();

    if (type === 'keydown' && event.key === 'Tab') {
      event.preventDefault();
    }


    // If the key is '~', enter unlimited mode for 100ms
    if (event.key === '~') {
      this.isUnlimitedMode = true;

      // Clear any existing timeout to reset the countdown
      if (this.unlimitedModeTimeout) {
        clearTimeout(this.unlimitedModeTimeout);
      }

      // Start a new timeout to disable unlimited mode after 300ms
      this.unlimitedModeTimeout = setTimeout(() => {
        this.isUnlimitedMode = false;
      }, 300);
    }

    // If we're in unlimited mode, allow the event to pass
    if (this.isUnlimitedMode || !this.lastEventTimestamp[type] || currentTime - this.lastEventTimestamp[type] >= 50) {
      this.lastEventTimestamp[type] = currentTime;


      // OLD
      const currentState = window.bm_state.value;
      const candidates = this.listeners.get(type).filter(
        (listener) =>
          listener.state === currentState || listener.state === "global.global"
      );


      if (this.listeners.has(type)) {
        this.listeners.get(type).forEach(listener => {

          if(window.ac && listener.flag){
            if(window.ac !== listener.flag){
              return; 
            }
          }

          listener(event)
        });
      }

      //   // NEW
      //   if (!this.listeners.has(type)) return;
      //   const currentState = window.bm_state.value;

      //   // Pick listeners that match current state or global
      //   const candidates = this.listeners.get(type).filter(
      //     (listener) => listener.state === currentState || listener.state === "global.global"
      //   );

      //   if (candidates.length === 0) return;


      //  // Most recently added wins
      // const activeListener = candidates[candidates.length - 1];

      // // Dispatch the event
      // activeListener(event);


    }
  }
}

const eventManager = new EventManager();
export default eventManager;
